/* <cookie-banner> — Shopify Customer Privacy API ile KVKK çerez onayı */
class CookieBanner extends HTMLElement {
  connectedCallback() {
    this.querySelector('[data-cookie-accept]')?.addEventListener('click', () => this.save(true));
    this.querySelector('[data-cookie-necessary]')?.addEventListener('click', () => this.save(false));
    this.load();
  }
  load() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) return;
      this.api = window.Shopify.customerPrivacy;
      if (this.api && typeof this.api.shouldShowBanner === 'function' && this.api.shouldShowBanner()) this.show();
    });
  }
  show() {
    this.hidden = false;
    requestAnimationFrame(() => this.classList.add('is-visible'));
    /* WhatsApp butonu bandın üstüne çıksın */
    this.resizeObserver = new ResizeObserver(() => this.setOffset());
    this.resizeObserver.observe(this);
  }
  setOffset(visible = true) {
    /* Bant yüksekliği + alt boşluğu */
    const offset = visible ? this.offsetHeight + (parseFloat(getComputedStyle(this).bottom) || 0) : 0;
    document.documentElement.style.setProperty('--cookie-banner-offset', `${offset}px`);
  }
  hide() {
    this.resizeObserver?.disconnect();
    this.setOffset(false);
    this.classList.remove('is-visible');
    /* Odak bant içindeyse ana içeriğe taşı */
    if (this.contains(document.activeElement)) document.getElementById('MainContent')?.focus({ preventScroll: true });
    setTimeout(() => (this.hidden = true), 200);
  }
  save(all) {
    if (!this.api) return this.hide();
    this.querySelectorAll('button').forEach((b) => (b.disabled = true));
    this.api.setTrackingConsent({ analytics: all, marketing: all, preferences: all }, () => this.hide());
  }
}
if (!customElements.get('cookie-banner')) customElements.define('cookie-banner', CookieBanner);
